import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastUpdateFormat',
  standalone: true,
})
export class LastUpdateFormatPipe implements PipeTransform {

  transform(value: string | Date | null | undefined): string {
    if (value === null || value === undefined) return '';

    const date = typeof value === 'string' ? new Date(value) : value;

    if (!(date instanceof Date) || isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).format(date);
  }
}